import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';
import Alert from '../../../common/Alert';
import Logo from '../../../common/Logo';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const AddTags = ({
    slideform4, 
    setSlideForm4,
    handleSubmit,
    formData, 
    onChange,
    is_create_page,
    processing
}) => {

    // Toggle the value of slideform to go back to the previous form step
    const goBack = (e) => {
        setSlideForm4(!slideform4);
    }

    const { relevant_keywords } = formData;

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}

            {/* Display the heading */}
            <div>
                <h2>Add relevant keywords</h2>
            </div>

            {/* Header Description */}
            <div>
                <div style={{color:'rgb(83, 100, 113)', textAlign:'center', fontSize:'1rem', fontWeight:'500', marginTop:'5px', lineHeight:'20px', overflowWrap:'break-word'}}>
                    <span>We use this to improve search. Separate keywords with a comma.</span>
                </div>
            </div>

            {/* Input Box for Bio text */}
            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <textarea
                    style={{width:'94%', padding:'10px', minHeight:'100px', resize: 'none', fontSize: '16px'}}
                    type="text"
                    placeholder="e.g. shoes, running shoes, sneakers"
                    className="input"
                    name="relevant_keywords"
                    value={relevant_keywords}
                    maxlength="160"
                    onChange={e => onChange(e)}
                />
            </div>

            <Button 
                disabled={!(relevant_keywords?.length > 0) || processing}
                onClick={handleSubmit}
                variant="outlined" 
                className={`sidebar__tweet ${relevant_keywords?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                {processing ? 'processing...' : 'Create Group'}
            </Button>

            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

            <div className="auth__footer">
                {/* <a href={`/register`}>Forgot password?</a>
                <a href={`/login`}>Log In</a> */}
            </div>
        </div>
    )
}

AddTags.propTypes = {

}

export default AddTags
